(() => {
class KyronCurvedNewsletter {
  constructor(section) {
    this.section = section;
    this.stage = section.querySelector('.kyron-newsletter__stage');
    this.svg = section.querySelector('.kyron-newsletter__svg');
    this.surface = section.querySelector('.kyron-newsletter__surface');
    this.border = section.querySelector('.kyron-newsletter__border');
    this.shape = section.querySelector("[id^='kyron-newsletter-shape']");
    this.textPath = section.querySelector("[id^='kyron-newsletter-text']");

    // Esta seção só usa o efeito curvo quando todos estes elementos existem.
    // Sem a checagem, uma newsletter comum causava o erro de clientWidth.
    if (!this.stage || !this.svg || !this.surface || !this.border || !this.shape || !this.textPath) return;

    this.resize = this.resize.bind(this);
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  resize() {
    const width = this.stage.clientWidth;
    const height = this.stage.clientHeight;

    if (!width || !height) return;

    this.svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    this.draw(width, height);
  }

  draw(width, height) {
    const radius = height * 0.5;
    const d = `M ${radius} 0 L ${width - radius} 0 Q ${width} 0 ${width} ${radius} L ${width} ${height - radius} Q ${width} ${height} ${width - radius} ${height} L ${radius} ${height} Q 0 ${height} 0 ${height - radius} L 0 ${radius} Q 0 0 ${radius} 0 Z`;

    this.surface.setAttribute('d', d);
    this.border.setAttribute('d', d);
    this.shape.setAttribute('d', d);
    this.textPath.setAttribute('d', `M 42 ${height * 0.53} L ${width - 230} ${height * 0.53}`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kyron-newsletter').forEach((section) => {
    new KyronCurvedNewsletter(section);
  });
});
})();
